import { Chicken } from "../types/Chicken";
import { ChickenItem } from "../components/ChickenItem";

export const ChickenSightingsList = ({ chickens, images, user_id }: { chickens: Chicken[], images: object, user_id: number}) => {
  return (
    <>
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 gap-y-10 gap-x-6 sm:grid-cols-2 lg:grid-cols-4 xl:gap-x-8">
          {chickens.map((chicken: Chicken) => (
            <ChickenItem key={chicken.attributes.annotation_id} chicken={chicken} image_url={images[chicken.attributes.annotation_id]} annotation_value={true} user_id={user_id} />
          ))}
        </div>
      </div>
    </>
  );
};
